import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Switch = ({ on = false, small = false, large = false, onChange, ...rest }) => (
	<label className={cn('switch', { 'switch-sm': small && !large, 'switch-lg': large && !small })}>
		<input type="checkbox" checked={on} onChange={onChange} {...rest} />
		<span />
	</label>
);

Switch.propTypes = {
	on: PropTypes.bool,
	small: PropTypes.bool,
	large: PropTypes.bool,
	onChange: PropTypes.func
};

export default Switch;
